import type { ContextGuards } from './types.js';

/**
 * @deprecated
 */
export function isControllerCompany(ctx: ContextGuards) {
  return ctx.profileService.isControllerCompany();
}
